import LoaderDots from './LoaderDots'

export default LoaderDots



// WEBPACK FOOTER //
// ./src/app/components/common/loaderDots/index.js